const compare = (prevField, nextField) => {
  return prevField > nextField ? 1 : prevField === nextField ? 0 : -1;
};
const sortComparator = (field, dir) => (prev, next) => {
  const prevField = prev[field]?.toLowerCase();
  const nextField = next[field]?.toLowerCase();
  if (dir === 'asc') {
    return compare(prevField, nextField);
  } else {
    return compare(nextField, prevField);
  }
};

export default sortComparator;
